// Import external
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[synLayoutContainer]'
})
export class LayoutContainerDirective implements OnInit {

    constructor(private ele: ElementRef) {
    }

    ngOnInit() {
        this.ele.nativeElement.className = this.ele.nativeElement.className +
            ' mdl-grid';
    }
}
